// An organization contact id in a shared insights URL: Django's numeric id, or the NestJS API's MongoDB ObjectId
// (the contact's user id). Drop the numeric one once Django is switched off.
export const ORG_CONTACT_ID_PATTERN = '\\d+|[0-9a-fA-F]{24}';

export default [
  // Protected route for logged-in educators
  {
    path: '',
    name: 'insights-private',
    meta: {
      educatorsOnly: true,
      renderNav: true,
      title: 'Insights',
    },
    component: () => import('@/views/educatorHub/dashboards/insights/Insights.vue'),
  },
  // Public route with orgContactId parameter
  {
    path: `:orgContactId(${ORG_CONTACT_ID_PATTERN})`,
    name: 'insights-shared',
    meta: {
      bypassAuth: true,
      renderNav: false,
      title: 'Insights - Shared',
    },
    component: () => import('@/views/educatorHub/dashboards/insights/Insights.vue'),
  },
];